<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
        
        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="30">
                      <v-img
                        contain
                        alt="tvandroid"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      Hotel Services
                    </span>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 py-0 pr-1">
            <v-col
              v-for="(item, index) in process.load ? 4 : list"
              :key="index"
              cols="12"
              md="6">
              <v-card v-if="process.load"
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text>
                  <v-row
                    class="px-4">
                    <v-col
                      cols="12"
                      md="4">
                      <v-skeleton-loader
                        :loading="process.load"
                        type="image">
                      </v-skeleton-loader>
                    </v-col>
                  </v-row>

                  <v-skeleton-loader
                    :loading="process.load"
                    type="article">
                  </v-skeleton-loader>
                </v-card-text>
              </v-card>

              <v-card v-if="!process.load"
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text
                  class="pb-0">
                  <div
                    class="body-1 font-weight-bold black--text mb-4">
                    {{ item.title }}
                  </div>

                  <folder v-if="item.thumbnail_image === ''"
                    v-model="upload.folder">
                    <div 
                      @click="item_index = index"
                      slot="activator">
                      <v-card 
                        flat
                        width="175"
                        height="175"
                        class="d-flex align-center justify-center cursor-pointer"
                        style="border-radius: 10px;
                              border: 2px solid #EBEBEB; 
                              border-style: dashed;">
                        <v-avatar v-if="!item.process"
                          v-ripple
                          tile 
                          width="175"
                          height="175">
                          <v-icon
                            size="50"
                            color="#B9B9B9">
                            mdi-cloud-upload-outline
                          </v-icon>
                        </v-avatar>

                        <v-progress-circular v-else
                          indeterminate
                          :color="set_color">
                        </v-progress-circular>
                      </v-card>
                    </div>
                  </folder>

                  <v-card v-if="item.thumbnail_image !== ''"
                    flat
                    width="175"
                    height="175"
                    class="d-flex align-center justify-center"
                    style="border-radius: 10px;
                          border: 2px solid #EBEBEB; 
                          border-style: dashed;">
                    <v-avatar v-if="!item.process"
                      v-ripple
                      tile 
                      width="175"
                      height="175">
                      <v-img 
                        width="100%"
                        height="100%"
                        alt="tvandroid" 
                        :src="item.thumbnail_image"
                        class="ma-auto"
                        style="border-radius: 10px;">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <v-icon 
                      @click="item.thumbnail_image = ''"
                      color="red"
                      class="cursor-pointer"
                      style="position: absolute; top: -10px; right: -10px;">
                      mdi-close-circle
                    </v-icon>
                  </v-card>

                  <div
                    class="body-2 font-weight-bold mt-6 mb-4">
                    Services Choice
                  </div>

                  <v-row
                    v-for="(item_sub, index_sub) in item.items_json_array"
                    :key="index_sub">
                    <v-col
                      cols="11"
                      class="py-0">
                      <v-text-field
                        v-on:keyup.enter="save()"
                        
                        filled
                        rounded
                        dense

                        :color="set_color"
                        :placeholder="`Ex : ${item_sub.placeholder}`"
                        :append-icon="item_sub.label !== '' ? 'mdi-check-circle-outline' : ''"

                        v-model="item_sub.label"
                        :success="item_sub.label !== ''"
                        required
                        style="border-radius: 10px;">
                      </v-text-field>
                    </v-col>

                    <v-col
                      cols="1"
                      class="py-0 pl-1">
                      <v-btn
                        @click="item_index = index; item_index_sub = index_sub; save_item();"
                        :loading="item_sub.process"
                        :disabled="process.form"
                        min-width="40"
                        min-height="40"
                        elevation="0"
                        color="#f0f0f0"
                        class="px-0"
                        style="border-radius: 8px;">
                        <v-icon>mdi-content-save-outline</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        dialog: {
          snackbar: false
        },
        
        list: [],

        upload: {
          folder: null
        },

        item_index: '',
        item_index_sub: '',

        process: {
          load: false,

          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      folder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'upload.folder': {
        handler: function () {
          if (this.upload.folder) {
            this.list[this.item_index].process = this.upload.folder.process

            if (!this.list[this.item_index].process) {
              this.list[this.item_index].thumbnail_image = this.upload.folder.file_url

              this.save_image()
            }
          }
        },
        deep: true
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch () {
        this.process.load = true

        await get(`admin/service/data`)
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.code === 200) {
            let data = res.result.data

            this.list = []

            data.map(obj => {
              let data_sub = []

              obj.items_json_array.map(obj_sub => {
                data_sub.push({
                  placeholder: obj_sub.label,
                  label: obj_sub.label,
                  image: obj_sub.image,
                  process: false
                })
              })

              this.list.push({
                id: obj.id,
                title: obj.title,
                type: obj.type,
                description: obj.description,
                thumbnail_image: obj.thumbnail_image,
                items_json_array: data_sub,
                process: false
              })
            })
          }
        })
      },

      async save_image () {
        this.message.error = ''

        this.process.form = true

        // SAVE TO REST API
        await post(`admin/service/update`, {
          data: this.list[this.item_index]
        })
        .then((response) => {
          let res = response.data

          this.process.form = false

          if (res.code === 200) {
            this.dialog.snackbar = true
            this.message.success = res.message
          } else {
            this.message.error = res.message
          }
        })
      },

      async save_item () {
        this.message.error = ''

        this.process.form = true

        this.list[this.item_index].items_json_array[this.item_index_sub].process = true

        // SAVE TO REST API
        await post(`admin/service/update`, {
          data: this.list[this.item_index]
        })
        .then((response) => {
          let res = response.data

          this.process.form = false

          this.list[this.item_index].items_json_array[this.item_index_sub].process = false

          if (res.code === 200) {
            this.dialog.snackbar = true
            this.message.success = res.message
          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>